import React from 'react';
import { Play } from 'lucide-react';
import VideoCard from './VideoCard';

const VideoSection = ({ title, videos }) => (
    <section>
        <div className="flex items-center gap-2.5">
            <Play className="h-[18px] w-[18px] text-[#38433A]" strokeWidth={1.75} />
            <h2 className="font-dashboard text-[11px] leading-5 uppercase tracking-[0.8px] text-[#2d2d2d]">
                {title}
            </h2>
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {videos.map((video) => (
                <VideoCard key={video.id} {...video} />
            ))}
        </div>
    </section>
);

export default VideoSection;
